import { Action } from '@ngrx/store';

export const GLOBAL_UNLOCK_SUCCESS = '[Customer] Global Unlock Success';

export class GlobalUnlockSuccessAction implements Action {
  readonly type = GLOBAL_UNLOCK_SUCCESS;
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/GlobalUnlockSuccessAction.ts